module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-tool"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeChapter(_vm.selected)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _vm._l((_vm.chapters), function(chapter) {
    return _c('option', [_vm._v(_vm._s(chapter))])
  })], 2), _vm._v(" "), (_vm.pause) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.playVideo()
      }
    }
  }, [_vm._v("Play")]) : _vm._e(), _vm._v(" "), (!_vm.pause) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.pauseVideo()
      }
    }
  }, [_vm._v("Pause")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.selected == ''
    },
    on: {
      "click": function($event) {
        _vm.setChapter()
      }
    }
  }, [_vm._v("Set as default")]), _vm._v(" "), (_vm.defaultChapter) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.removeDefaultChapter()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.forwardVideo()
      }
    }
  }, [_vm._v("Forward")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentChapter))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b00d85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/DebugTool.vue
// module id = 708
// module chunks = 64